module.exports = "/* You can add global styles to this file, and also import other style files */\n/*@import \"~@angular/material/prebuilt-themes/indigo-pink.css\";*/\np, h1, h2, h3, h4, body{\n\tfont-family: montserrat;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles